import { render } from "./SignInConfirmPhone.vue?vue&type=template&id=6c898a82&scoped=true"
import script from "./SignInConfirmPhone.vue?vue&type=script&lang=js"
export * from "./SignInConfirmPhone.vue?vue&type=script&lang=js"

import "./SignInConfirmPhone.vue?vue&type=style&index=0&id=6c898a82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c898a82"]])

export default __exports__